/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { TrendingIcon } from '@coursera/cds-icons';

import { type MarketingStatusTag, trendingNowColors } from 'bundles/product-card/components/utils/marketingTagUtils';
import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';

const styles = {
  svg: css`
    vertical-align: middle;
    margin-inline-end: var(--cds-spacing-25);
    margin-bottom: 2px;
  `,
};

type Props = {
  marketingTag: MarketingStatusTag;
};

const TrendingRightNowBadge = ({ marketingTag }: Props) => {
  return (
    <Badge color={trendingNowColors}>
      <TrendingIcon size="small" css={styles.svg} />
      {marketingTag.tag}
    </Badge>
  );
};

export default TrendingRightNowBadge;
